import React from "react"
import { Slide } from "../../../../../ui/animations/Slide"
import { newUuid } from "../../../../../utils"
import { mergeFilter } from "../../../utils/filters"
import FilterCategoriesList from "../FilterCategoriesList"
import FilterCategoryContent from "../FilterCategoryContent"
import FiltersPanelFooter from "../FiltersPanelFooter"
import FiltersPanelHead from "../FiltersPanelHead"
import { CheckboxFilterOption, FilterCategory } from "../types"

interface Props {
  title: string
  categories: FilterCategory[]
  selectedCategory: FilterCategory | undefined
  selectedParent?: CheckboxFilterOption
  onCategorySelected: (category: FilterCategory) => void
  onCancel: () => void
  onClear: () => void
  onConfirm: () => void
  onFiltersUpdate: (filters: FilterCategory[]) => void
  onOptionExpand: (item: CheckboxFilterOption) => void
  onOptionBack: () => void
}

const FilterCategoriesPanel = ({
  categories,
  title,
  selectedCategory,
  selectedParent,
  onCancel,
  onClear,
  onConfirm,
  onCategorySelected,
  onFiltersUpdate,
  onOptionExpand,
  onOptionBack,
}: Props) => {
  const [key, setKey] = React.useState(newUuid())
  return (
    <div>
      <div className="sticky top-0 z-10 bg-white">
        <FiltersPanelHead
          title={title}
          onBackClick={() => (selectedParent ? onOptionBack() : onCancel())}
          onRemoveClick={onClear}
        />
      </div>
      <div className="pb-12">
        {!selectedCategory && (
          <FilterCategoriesList
            categories={categories}
            onCategoryClick={onCategorySelected}
          />
        )}
        <Slide
          in={selectedCategory !== undefined}
          from="right"
          style={{ height: "100%" }}
        >
          <div className="h-full">
            {selectedCategory && (
              <div className="h-full px-1 pb-4">
                <FilterCategoryContent
                  className="h-full"
                  key={key}
                  item={
                    categories.find(
                      (x) => x.id === selectedCategory.id
                    ) as FilterCategory
                  }
                  parent={selectedParent}
                  onItemUpdate={(item) => {
                    onFiltersUpdate(mergeFilter(categories, item))
                    setKey(newUuid())
                  }}
                  onOptionExpand={onOptionExpand}
                />
              </div>
            )}
          </div>
        </Slide>
      </div>
      <div className="fixed bottom-0 w-full bg-white z-1">
        <FiltersPanelFooter
          ctaLabel="Mostra risultati"
          onCtaClick={onConfirm}
        />
      </div>
    </div>
  )
}

export default FilterCategoriesPanel
